import * as Yup from "yup";

export const schema = Yup.object().shape({
  servicesType: Yup.string().required("Service type required"),
  servicesPosition: Yup.string().required("Service position required"),
  servicePlan: Yup.string().when("servicesType", {
    is: (val) => val !== "Moving",
    then: (schema) => schema.required("Service plan required"),
    otherwise: (schema) => schema.notRequired(),
  }),

  numberOfRooms: Yup.string().required("Number of rooms required"),

  firstName: Yup.string().trim().required("Name is required"),

  tel: Yup.string()
    .matches(
      /^\+998 \d{2} \d{3} \d{2} \d{2}$/,
      "Phone number must be in the format +998 xx xx xx xx"
    )
    .required("Phone number is required"),

  tashkentDistricts: Yup.string().required("Select your Tashkent district"),
  address: Yup.string().trim().required("Address is required"),
});
